var _defs, _path, _path2, _path3, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b7b7b7;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.7,9,10,9.26C9.19,8,9.49,6.18,7.75,5.33V7.39H6.88v-2A1.55,1.55,0,0,0,5.57,6.91a16.83,16.83,0,0,0,0,1.74.85.85,0,0,0,.24.56,1.73,1.73,0,0,1,.63,1.66c0,1,0,2,0,3.06H5.56c0-1,0-2.1,0-3.16A1.21,1.21,0,0,0,5.25,10a1.58,1.58,0,0,1-.57-1.47,6.42,6.42,0,0,0,0-1.16A2.78,2.78,0,0,1,6,4.75c-.59-1.23-.51-2,.27-2.62a1.69,1.69,0,0,1,2.14,0c.76.63.83,1.39.25,2.54C9.65,5.62,10.24,6.85,10.7,9ZM8.18,3.5c-.07-.53-.35-.87-.9-.86a.78.78,0,0,0-.83.82.78.78,0,0,0,.83.89C7.83,4.37,8.11,4,8.18,3.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9,13.93H8.21V9.2H9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10,10.07h.78v3.86H10Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.19,
    y: 13.2,
    width: 2.41,
    height: 0.73
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAging);
export default __webpack_public_path__ + "static/media/aging.ecb075a55db8d14a1e0db74544f5c0bf.svg";
export { ForwardRef as ReactComponent };